<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      v-if="trendShow"
      row-key="UserId"
      ref="list"
      unit="采购需求单"
      :page="page"
      :show-query="true"
      :show-checkbox="true"
      :get-data-func="api.list"
      :temp-params="tempParams"
      @row-select="rowSelect"
      @onSelCheck="onSelCheck"
      @onAllCheck="onAllSelCheck"
      urlHash="production/clothmanagement/newdemandSelect"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    <el-button type="primary" @click="onCustomTable1" icon="el-icon-s-tools" style="margin: 10px 0">明细项</el-button>
    <el-table ref="multipleTable" v-if="show" :data="tableData" @selection-change="handleSelectionChange" :row-key="row => row.Prop" max-height="600" stripe border>
      <el-table-column type="selection" width="55"></el-table-column>
      <template v-for="(item, index) in tableColumns1">
        <!-- 需判断是否有价格的权限  -->
        <template v-if="item.IsShow">
          <el-table-column
            :resizable="false"
            :fixed ="item.Fixed ?? false"
            :key="`${item.Prop}-${index}`"
            :prop="item.Prop"
            v-if="shouldShowColumn(item)"
            :label="item.Label"
            :align="item.Align ?? 'left'"
            :min-width="item.Width"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              <span v-if="isNumericProperty(item.Prop)">{{ $commonJs.toThousands(row[item.Prop]) }}</span>
              <span v-else>{{ row[item.Prop] }} </span>
            </template>
          </el-table-column>
        </template>
      </template>
    </el-table>
    <customTableDialog1 ref="customTableDialog1" @onSave="onSave1" :initTableData="tableColumns1" tableType="采购需求单明细" />
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'
import customTableDialog1 from '@/components/common/customTableDialog/customTableDialog'

export default {
  mixins: [listMixin],
  components: { list, customTableDialog1 },
  props: {
    // canPrice: {
    //   typeof: Boolean,
    //   default: true,
    // }
  },
  data() {
    return {
      api: require('@/api/production/clothProduction').default,
      sourceTypeApi: require('@/api/ba/sourceType').default,
      FieldSettingApi: require('@/api/sy/fieldSetting').default,
      puPurchaseDemandApi: require('@/api/pu/puPurchaseDemand').default,
      trendShow: true,
      tableData: [],
      tempParams: {
        ProductionStatus: 1,
        IsCloth: true
      },
      tableColumns1: [],
      show: false,
      activeName: 'first',
      orderProductNos: [],
      subSelectList: []
    }
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice('/business/stock/outsourcingpicking')
    }
  },
  created() {
    this.getTableColumns1()
  },
  methods: {
    /** 价格权限的字段 */
    shouldShowColumn(item) {
      if (!item.IsShow) return false
      const priceProps = ['PurchasePrice', 'SalePrice', 'RetailPrice', 'QuotedPrice', 'Discount', 'TaxRate', 'Price', 'TaxPrice', 'Amount', 'TaxLimit', 'TaxAmount', 'DiscountAmount', 'Rate', 'Price']
      return (this.canPrice && priceProps.includes(item.Prop)) || !priceProps.includes(item.Prop)
    },
    /** 千位符格式化数字类型 */
    isNumericProperty(prop) {
      return ['PuQuantity', 'Amount', 'TaxAmount'].includes(prop)
    },
    toggleSelection(rows) {
      let $multipleTable = this.$refs.multipleTable
      if ($multipleTable) {
        if (rows) {
          rows.forEach(row => {
            $multipleTable.toggleRowSelection(row)
          })
        } else {
          $multipleTable.clearSelection()
        }
      }
    },
    clearSubSelectList() {
      this.toggleSelection()
    },
    async getTableColumns1() {
      const res = await this.FieldSettingApi.list({ Type: '采购需求单明细' })
      this.tableColumns1 = []
      this.tableColumns1 = res.Data
    },
    onCustomTable1() {
      this.$refs.customTableDialog1.dialogVisible = true
    },
    handleSelectionChange(data) {
      this.subSelectList = data;
    },
    onSave1() {
      this.getTableColumns1()
      this.$message.success('保存成功')
    },
    getMachiningStageList() {
      this.machiningStageApi.list({ Status: 1 }).then(res => {
        res.Data.forEach(item => {
          this.machiningStageList.unshift({ value: item.Name, label: item.Name })
        })
      })
    },
    rowSelect(row) {
      // this.activeName = 'first'
      // this.show = true
      // let id = row.DocId;
      // this.puPurchaseDemandApi.getVPrWorkDocMaterialList(id).then(res => {
      //   this.tableData = res.Data.Products;
      // })
    },
    onSelCheck(selection) {
      if (selection.length == 0) {
        this.tableData = []
        this.orderProductNos = []
        return
      }
      this.activeName = 'first'
      this.show = true
      const OrderProductNos = selection.map(item => item.OrderProductNo)
      this.orderProductNos = OrderProductNos
      const o = {
        OrderType: 25,
        ProcessStage: 0,
        ShowAll: false,
        OrderProductNos: OrderProductNos
      }
      this.puPurchaseDemandApi.getVPrWorkDocMaterialList(o).then(res => {
        this.tableData = res.Data
      })
    },
    onAllSelCheck(selection) {
      if (selection.length == 0) {
        this.tableData = []
        this.orderProductNos = []
        return
      }
      this.activeName = 'first'
      this.show = true
      const OrderProductNos = selection.map(item => item.OrderProductNo)
      this.orderProductNos = OrderProductNos
      const o = {
        OrderType: 25,
        ProcessStage: 0,
        ShowAll: false,
        OrderProductNos: OrderProductNos
      }
      this.puPurchaseDemandApi.getVPrWorkDocMaterialList(o).then(res => {
        this.tableData = res.Data
      })
    }
  }
}
</script>
